module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAAiElEQVQoke3SwRGCMBSE4Y8MTVCLWgB1aCE2QjV6tA2RLvCAzDwzYVC8+l+S2dndvExSOd9kjK+1+kRPaNEHQx5a0nu0CR2agmmNBl0K4UPBVOUjZ96mDuI1hEpEffaKBaW7rhILlk5eYmR6hZ/4F7wX7L/I7eZNjYfpN142DDAknDBsCN9xfAIiuBUlNX0+jQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/router-detail-icon1.png
// module id = jQIc
// module chunks = 1